import GoogleMapTemplate from 'src/components/etc/GoogleMap/template'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import {
  resetSelectPin,
  setMarkerIndex,
  setSelectPin,
} from 'src/store/Reducer/page/locationPageSlice'
import { CurrentLocationTempObject } from 'src/components/atomic/organisms/views/Location/LocationCurrentInfo'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { useEffect } from 'react'
import useMatchHook from 'src/hooks/useMatch.hook'
import Div from 'src/components/atomic/atom/Div'
import { SvcLocationType } from 'src/types/websocket'

export type GoogleMapDataPropsType = {
  NowMarkerDispatch: () => void
  NumMarkerDispatch: (data: SvcLocationType) => void
}
const GoogleMap = () => {
  const { XVal, YVal, Address, Date } = useAppSelector((state: RootState) => state.currentLocation)
  const dispatch = useAppDispatch()
  const { m_location, m_location_detail } = useMatchHook()
  const { LocationInfos } = useAppSelector((state: RootState) => state.locationHistory)
  const NowMarkerDispatch = () => {
    dispatch(
      setSelectPin({
        ...CurrentLocationTempObject,
        XVal: XVal,
        YVal: YVal,
        Address: Address,
        Date: Date,
      }),
    )
  }
  const NumMarkerDispatch = (data: SvcLocationType) => {
    dispatch(setSelectPin(data))
  }

  //위치 찾기 페이지 이탈시 초기화
  useEffect(() => {
    if (!m_location && !m_location_detail) {
      dispatch(resetSelectPin())
      dispatch(setMarkerIndex(null))
    }
  }, [m_location, dispatch, m_location_detail])

  // mobile, tablet 에서 params 처리
  useEffect(() => {
    if (m_location_detail) {
      if (m_location_detail.params.idx === '-1') {
        dispatch(
          setSelectPin({
            ...CurrentLocationTempObject,
            XVal: XVal,
            YVal: YVal,
            Address: Address,
            Date: Date,
          }),
        )
      } else {
        const findData = LocationInfos.find(
          (w: SvcLocationType) => w.Idx === Number(m_location_detail.params.idx),
        )
        dispatch(setSelectPin(findData))
      }
    }
  }, [m_location_detail, dispatch, LocationInfos, Address, XVal, YVal, Date])

  const data: GoogleMapDataPropsType = {
    NumMarkerDispatch,
    NowMarkerDispatch,
  }

  return (
    <Div style={{ visibility: !m_location || !m_location_detail ? 'unset' : 'hidden' }}>
      <GoogleMapTemplate data={data} />
    </Div>
  )
}
export default GoogleMap
